export default __webpack_public_path__ + "static/media/down.2a35d8c4.svg";